import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Importando Link do react-router-dom
import Container from '../components/Container';
import AnimatedHeader from '../components/Header';
import Nav from '../components/Nav';
import MemeImage from '../components/MemeImage';
import cat from '../assets/cat.png';
import { FaTelegramPlane } from 'react-icons/fa';
import { Button, TwitterButton } from '../components/styles.js';

const Home = () => {
  const [activeLink, setActiveLink] = useState(null);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setTimeout(() => {
      setActiveLink(null);
    }, 100);
  };

  return (
    <Container>
      <AnimatedHeader />
      <Nav activeLink={activeLink} handleLinkClick={handleLinkClick} />

      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        width: '100%', 
        padding: '20px', 
        gap: '30px',
        marginTop:'80px',
        fontFamily: '"Comic Sans MS", "Comic Sans", cursive',
      }}>
        {/* Texto e Botões no lado esquerdo */}
        <div style={{ textAlign: 'left' }}>
          <h1 style={{ color: '#333333', marginBottom: '5px' }}>Little Paul</h1>
          <h2 style={{ color: '#666666', marginBottom: '5px' }}>A ONE-EYED CAT ON SOLANA</h2>
          <h3 style={{ color: '#999999', marginBottom: '8px' }}>CA: SOON  </h3>

          {/* Botões abaixo do texto */}
          <div style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
            {/* Usando Link para navegar para MemeBuilder */}
            <Link to="/meme-builder" style={{ textDecoration: 'none' }}>
              <Button>
                Create a Cat
              </Button>
            </Link>

            <Link to="https://www.tiktok.com/@paulinhobicudoofc" style={{ textDecoration: 'none' }}>
            <Button style={{ backgroundColor: '#000', color: '#fff', border: '2px solid white' }}>Tik Tok</Button>
            </Link>

            <TwitterButton href="https://x.com/OneEyedCatSol" target="_blank">
              Twitter
            </TwitterButton>

            <Link to="/lore" style={{ textDecoration: 'none' }}>
            <Button style={{ backgroundColor: '#4555', color: '#000', border: '2px solid white' }}>Lore</Button>
            </Link>

            <a href="https://t.me/+0g6go8ciAPUzOGEx" style={{ textDecoration: 'none' }}>
            <Button style={{ backgroundColor: '#fff', color: '#000', border: '2px solid #000' }}>
              <FaTelegramPlane style={{ marginRight: '2px' }} />
            </Button>
          </a>

            
          </div>
        </div>

       
        <div>
          <MemeImage src={cat} alt="cat" />
        </div>
      </div>
    </Container>
  );
};

export default Home;
